export default function ShopifyTitle({ data: { integration } = {} }) {
  return (integration && integration.storeName) || 'Shopify'
}
